import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Checkbox } from 'primereact/checkbox';
import * as XLSX from "xlsx";        
import CourseCombo from '../combos/CourseCombo';
import EduMonthCombo from '../combos/EduMonthCombo';
import FaDate from '../shared/FaDate';
import FinalScoreSave from './FinalScoreSave'
import TeacherSchoolClassCourseCombo from '../combos/TeacherSchoolClassCourseCombo';
import { Col, Form, Row } from 'react-bootstrap';

export default function TeacherFinalScores(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  
  const [items, setItems] = useState([]);

  const [editFormVisible, setEditFormVisible] = useState(false);
  const [schoolClassId, setSchoolClassId] = useState("");
  const [schoolClassDegree, setSchoolClassDegree] = useState(-1);
  const [courseId, setCourseId] = useState("");
  const [continualTestId, setContinualTestId] = useState("");
  const [month, setMonth] = useState(null);
  
  useEffect(() => {
  }, []);
  const searchFinalScoreStates = function(){
    if((month == null)||(month == {})||(month == "")||(month <= 0)){
      setErorVisible(true);
      setErrorMessage("ماه تحصیلی را مشخص نمائید");
      return;
    }

      var params = {login:util.getTrustedUser(), monthInd:month};
      var url = config.Server+`/school/teacher/month/final-score/state/list`;

      setLoading(true);
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                var items = response.data;
                console.log("courses is>", items)
                setLoaded(true);
                setLoading(false);
                setItems(items);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setLoading(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
  }
  const onContinualTestChanged = function (scId, cId){
    var tmp = {...items};
    for(var i=0;i<tmp.items.length;i++){
      var state = tmp.items[i];
      if((state.schoolClass.id == scId)&&(state.course.id == cId)){
        tmp.items[i].done = true;
      }
    }
    setItems(tmp);
  }
  const showEditForm = function (scId, deg, cId, id){
    setSchoolClassId(scId);
    setSchoolClassDegree(deg);    
    setCourseId(cId);
    setContinualTestId(id);
    setEditFormVisible(true);
  }
  return(      
    <>   
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>نمرات نهائی ماهانه</div>
      {
        loaded?
        <>
        <div className="" style={{ width:"calc(100% - 0px)"}}>
          <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col>
                  <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right", position:"relative", width:"calc(100% - 20px)"}}>
                    <Button style={{width:"200px"}} label="انتخاب ماه تخصیلی" icon="pi pi-check" onClick={()=>setLoaded(false)} loading={loading} severity="primary" iconPos="right" />
                    <div style={{position:"absolute", right:"220px", top:"10px", direction:"rtl"}}>
                      [{month}]&nbsp;{util.getMonthName(month)}
                    </div>
                  </div>
                </Col>
              </Row>
          </div>
        </div>
          <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>
            <table style={{borderCollapse:"collapse", margin:"10px"}}>
              <tr>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", width:"30px", backgroundColor:"#808080", color:"#ffffff"}}>#</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:"#808080", color:"#ffffff"}}>کلاس</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:"#808080", color:"#ffffff"}}>درس</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", width:"40px", backgroundColor:"#808080", color:"#ffffff"}}>ثبت</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", width:"100px", backgroundColor:"#808080", color:"#ffffff"}}>&nbsp;</td>
                <td >&nbsp;</td>
              </tr>
              {
                items.items.map((row, index)=>{
                  return(
                    <tr>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>{(index+1)}</td>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>{row.schoolClass.name}</td>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>{row.course.name}</td>
                      <td style={{padding:"5px 10px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>
                        {row.done?
                        <div style={{width:"20px", height:"20px", backgroundColor:"#44ee44", borderRadius:"50%"}}></div>
                        :
                        <div style={{width:"20px", height:"20px", backgroundColor:"#ee4444", borderRadius:"50%"}}></div>
                        }
                      </td>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>
                        <Button onClick={()=>showEditForm(row.schoolClass.id, row.schoolClass.degree, row.course.id, row.continualTestId)} >ثبت نمره</Button>
                      </td>
                      <td ></td>
                    </tr>
                  )
                })
              }
            </table>
          </div>
        </>
        :
        <div className="" style={{ width:"calc(100% - 0px)"}}>
          <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col md={3}>
                  <EduMonthCombo value={month} onChange={(value)=>{setMonth(value)}} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                    <Button label="ادامه" icon="pi pi-search" onClick={()=>searchFinalScoreStates()} loading={loading} severity="primary" iconPos="right" />
                  </div>
                  
                </Col>
              </Row>
          </div>
        </div>
      }
      {
        editFormVisible?
        <FinalScoreSave schoolClassId={schoolClassId} schoolClassDegree={schoolClassDegree} courseId={courseId} monthInd={parseInt(month)} isAgent={false} onChange={(scId, cId)=>{onContinualTestChanged(scId, cId)}} onClose={()=>setEditFormVisible(false)} />
        :
        <></>
      }
    <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
    </>  
  );
}
